import FacebookLogo from '../../../assets/facebook.png';
import InstagramLogo from '../../../assets/instagram.png';
import LinkedinLogo from '../../../assets/linkedin.png';
import TwitterLogo from '../../../assets/twitter.png';

export interface IPlatformProps {
    name: string;
    logo: string;
    color: string;
}

const Facebook: IPlatformProps = {
    name: 'Facebook',
    logo: FacebookLogo,
    color: '#217BEE',
};

const Linkedin: IPlatformProps = {
    name: 'Linkedin',
    logo: LinkedinLogo,
    color: '#0A66C2',
};

const Twitter: IPlatformProps = {
    name: 'Twitter',
    logo: TwitterLogo,
    color: '#1DA1F2',
};

const Instagram: IPlatformProps = {
    name: 'Instagram',
    logo: InstagramLogo,
    color: '#E4405F',
};

const PLATFORMS: { [key: string]: IPlatformProps } = {
    FACEBOOK: Facebook,
    LINKEDIN: Linkedin,
    INSTAGRAM: Instagram,
    TWITTER: Twitter,
};

export function getPlatformDataWithPlatformName(serviceName: string) {
    return PLATFORMS[
        // @ts-ignore
        Object.keys(PLATFORMS).filter(
            (f) => PLATFORMS[f].name.toString() === serviceName,
        )
    ];
}

export default PLATFORMS;
